<template>
  <v-card
    class="elevation-10 radius-10 fill-height"
    :style="!dense ? 'border-top: 5px solid ' + color : undefined"
  >
    <v-card-text
      class="grey--text text--darken-2"
      :class="{ 'px-6 py-3': dense, 'pa-6': !dense }"
    >
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    color: {
      type: String,
      default: '#ffffff'
    },
    dense: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
